import { API_BASE_URL } from "../urls.api";

export const TASK_TYPES_URL = `${API_BASE_URL}/task-types`;
